import {
  App,
  Button,
  Card,
  Col,
  Empty,
  Input,
  Pagination,
  Popconfirm,
  Row,
  Spin,
} from "antd";

import {
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import { useCallback, useEffect, useState } from "react";

import {
  DELETE_IMAGE_VIEW,
  LIST_IMAGE_VIEW,
} from "../../../apis/apis";

import AddImage from "./AddImage";

function ListImages(props) {
  const { message } = App.useApp();

  const { folder_name } = props;

  const [loading, set_loading] = useState(false);
  const [image_list, set_image_list] = useState([]);

  const [add_image, set_add_image] = useState(false);

  const [list_refresh, set_list_refresh] =
    useState(false);

  const [search, set_search] = useState("");

  const [currentPage, setCurrentPage] =
    useState(1);

  const [pageSize, setPageSize] = useState(8);

  const fetchImages = useCallback(async () => {
    set_loading(true);

    try {
      const response = await LIST_IMAGE_VIEW({
        search,
        folder_name,
      });

      if (response?.data?.status) {
        set_image_list(
          response?.data?.data || []
        );
      }
    } catch (error) {
      console.error(error);
    }

    set_loading(false);
  }, [search, folder_name]);

  useEffect(() => {
    fetchImages();
  }, [fetchImages, list_refresh]);

  const deleteImage = async (id) => {
    try {
      const response =
        await DELETE_IMAGE_VIEW(id);

      if (response?.data?.status) {
        message.success(
          "Image deleted successfully"
        );

        set_list_refresh((prev) => !prev);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const filteredList = image_list || [];

  const paginatedData = filteredList.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  if (add_image) {
    return (
      <AddImage
        set_add_image={set_add_image}
        list_refresh={list_refresh}
        set_list_refresh={set_list_refresh}
      />
    );
  }

  return (
    <div>
      <Row
        justify="space-between"
        align="middle"
        gutter={[16, 16]}
        style={{ marginBottom: 20 }}
      >
        <Col xs={24} sm={12}>
          <Input
            placeholder="Search by title"
            value={search}
            onChange={(e) =>
              set_search(e.target.value)
            }
          />
        </Col>

        <Col>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() =>
              set_add_image(true)
            }
          >
            Add Image
          </Button>
        </Col>
      </Row>

      {loading ? (
        <div
          style={{
            textAlign: "center",
            padding: "40px 0",
          }}
        >
          <Spin
            indicator={
              <LoadingOutlined spin />
            }
          />
        </div>
      ) : (
        <>
          {paginatedData?.length > 0 ? (
            <>
              <Row gutter={[16, 16]}>
                {paginatedData?.map(
                  (item, index) => (
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={6}
                      key={index}
                    >
                      <Card
                        hoverable
                        cover={
                          <img
                            alt={item?.title}
                            src={item?.image}
                            style={{
                              height: 220,
                              objectFit:
                                "cover",
                            }}
                          />
                        }
                        actions={[
                          <Popconfirm
                            title="Delete Image"
                            description="Are you sure to delete this image?"
                            onConfirm={() =>
                              deleteImage(
                                item?.id
                              )
                            }
                            okText="Yes"
                            cancelText="No"
                          >
                            <DeleteOutlined key="delete" />
                          </Popconfirm>,
                        ]}
                      >
                        <Card.Meta
                          title={
                            <div
                              style={{
                                whiteSpace:
                                  "nowrap",
                                overflow:
                                  "hidden",
                                textOverflow:
                                  "ellipsis",
                              }}
                            >
                              {item?.title}
                            </div>
                          }
                        />
                      </Card>
                    </Col>
                  )
                )}
              </Row>

              <Row
                justify="end"
                style={{ marginTop: 20 }}
              >
                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={filteredList.length}
                  onChange={(page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  }}
                  showSizeChanger
                />
              </Row>
            </>
          ) : (
            <Card style={{ marginTop: "15px" }}>
              <Empty description="No data" />
            </Card>
          )}
        </>
      )}
    </div>
  );
}

export default ListImages;